export enum ModeCode {
  GfsAir = 'A', // GFS mode code for Air
  GfsOcean = 'S', // GFS mode code for Ocean
}
